'use client';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NextUIProvider } from '@nextui-org/system';
import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { ThemeProviderProps } from 'next-themes/dist/types';
import { RootState } from '@/redux/store';

interface LocaleProviderProps {
  children: React.ReactNode;
  themeProps?: ThemeProviderProps;
}

const LocaleProvider: React.FC<LocaleProviderProps> = ({
  children,
  themeProps,
}) => {
  const { company } = useSelector((state: RootState) => state.auth);

  // const company = useSelector((state: RootState) => state.auth.company);
  const [locale, setLocale] = useState<string>('en-US');

  const mapDateFormatWithLocale = (format?: string) => {
    switch (format) {
      case 'dd/MM/yyyy':
        return 'en-GB'; // UK
      case 'MM/dd/yyyy':
        return 'en-US'; // US
      case 'yyyy-MM-dd':
        return 'en-SE'; // Sweden
      case 'MMM dd, yyyy':
        return 'en-US'; // US format
      default:
        return 'en-US'; // Default to US if no match
    }
  };

  useEffect(() => {
    try {
      if (company?.date_format?.frontend_format) {
        const detectedLocale = mapDateFormatWithLocale(
          company?.date_format?.frontend_format,
        );
        console.log('Detected Locale:', detectedLocale);
        setLocale(detectedLocale);
      }
      // Note: We keep the default 'en-US' locale instead of setting it again
    } catch (error) {
      console.error('Error in LocaleProvider useEffect:', error);
      // Keep default locale on error
    }
  }, [company]);

  return (
    <NextUIProvider locale={locale}>
      <NextThemesProvider
        defaultTheme="light"
        attribute="class"
        {...themeProps}
      >
        {children}
      </NextThemesProvider>
    </NextUIProvider>
  );
};

export default LocaleProvider;
